export const AppLanguage = {
  French: 'fr',
  English: 'en',
  Catalan: 'ca',
  Deutsch: 'de',
  Espanol: 'es',
  Nederlands: 'nl' 	
};
export const AppDefaultLanguage = AppLanguage.French;